import React, { useState, useEffect, useRef } from "react";
import { func, object, bool, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import MobileLogo from "../../atoms/MobileLogo";
import SearchIcon from "../../atoms/icons/search-icon";
import VerticalMenubar from "../VerticalMenubar";
import { setVerticalMenuBar } from "../../helper/actions";
import { Link } from "@quintype/components";

import { getSectionsDataForHeader, getDomainSectionInfo } from "../../utils/utils";
import { useStyleMenubar, useDeviceWidth, logoRenderer } from "../../utils/react-utils";

import "./secondarySectionHeaderTopContent.m.css";

const SecondarySectionHeaderTopContent = ({
  isVerticalMenubar,
  setVerticalMenuBar,
  pageType,
  collection,
  sections,
  hamburgerMenu,
  domainInfo,
  domainSlug = "",
  navbarMenu,
  publisherAttributes
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [domainSectionObj, setSectionDomainObj] = useState({});
  const ref = useRef(null);
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const sectionsDataForHeader =
    collection.template !== "default" &&
    getSectionsDataForHeader(sections, domainSlug, collection.metadata.section, domainSectionObj);
  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  useEffect(() => {
    setSectionDomainObj(getDomainSectionInfo(domainSlug, sections));
  }, [domainSlug]);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const sectionMenuItem = () => {
    if (sectionsDataForHeader.parentSection && navbarMenu && navbarMenu.length > 0) {
      if (`https://${domainSlug}.qtstage.io/` === sectionsDataForHeader.parentSectionUrl) {
        return navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl);
      } else {
        return navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.parentSectionUrl);
      }
    } else {
      return navbarMenu.find(item => item.completeUrl === sectionsDataForHeader.currentSectionUrl);
    }
  };

  const sectionMenuDom = () => {
    return (
      <nav styleName="navbar">
        <ul styleName="parent-section">
          <li className="section">
            <a href={sectionMenuItem().completeUrl}>{sectionMenuItem().title}</a>
          </li>
        </ul>
        <ul styleName="sub-sections" className="sub-sections">
          {sectionMenuItem().children.length > 0 &&
            sectionMenuItem()
              .children.slice(0, 12)
              .map((item, index) => (
                <li
                  styleName={`child-section ${publisherAttributes.lang === "en" ? "en-child-section" : ""}`}
                  className={` ${item.title} child-section ${
                    sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""
                  }`}
                  key={index}
                >
                  {item.completeUrl === "/#" ? (
                    <span>{item.title}</span>
                  ) : (
                    <Link href={item.completeUrl}>{item.title}</Link>
                  )}
                </li>
              ))}
        </ul>
      </nav>
    );
  };

  const getBigSectionName = () => {
    if (
      (domainSlug && sectionsDataForHeader.parentSectionId !== domainSectionObj.id) ||
      (sectionsDataForHeader.parentSection && !domainSlug)
    ) {
      return (
        <li className="section">
          <Link href={sectionsDataForHeader.parentSectionUrl}>{sectionsDataForHeader.parentSection}</Link>
        </li>
      );
    } else {
      return (
        <li className="section">
          <Link href={sectionsDataForHeader.currentSectionUrl}>{sectionsDataForHeader.currentSection}</Link>
        </li>
      );
    }
  };

  const childSectionsDom = () => {
    return collection.template === "section" ? (
      pageType === "section-page" ? (
        <nav styleName="navbar">
          <ul styleName="parent-section">{getBigSectionName()}</ul>
          <ul styleName="sub-sections" className="sub-sections">
            {sectionsDataForHeader.childSections.slice(0, 12).map((item, index) => (
              <li
                styleName={`child-section ${publisherAttributes.lang === "en" ? "en-child-section" : ""}`}
                className={` ${
                  sectionsDataForHeader.currentSectionUrl === item["section-url"] ? "current-section" : ""
                } child-section`}
                key={index}
              >
                <Link href={item["section-url"]}>{item["display-name"]}</Link>
              </li>
            ))}
          </ul>
        </nav>
      ) : (
        <nav styleName="navbar">
          <ul styleName="parent-section" className="collection-name">
            <li className="collection">{collection.name}</li>
          </ul>
        </nav>
      )
    ) : (
      <nav styleName="navbar">
        <ul styleName="parent-section default-collection">
          <li className={`${collection.template === "default" ? "section default-collection" : "section"}`}>
            {collection.name}
          </li>
        </ul>
      </nav>
    );
  };

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={!!isVerticalMenubar}
              isDesktop={isDesktop}
            />
            <span styleName="search-icon" onClick={toggleSearchIcon}>
              <SearchIcon domainSlug={domainSlug} />
            </span>
            {isDesktop && <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>}
          </div>
          {isVerticalMenubar && (
            <VerticalMenubar
              isVerticalMenubar={isVerticalMenubar}
              isDesktop={isDesktop}
              domainInfo={domainInfo}
              toggleVerticalMenubar={toggleVerticalMenubar}
              hamburgerMenu={hamburgerMenu}
            />
          )}
        </div>
        <div styleName="logo">{logoRenderer(<MobileLogo />)}</div>
        {navbarMenu && navbarMenu.length > 0 && sectionMenuItem() ? sectionMenuDom() : childSectionsDom()}
      </div>
    </div>
  );
};

SecondarySectionHeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  menu: array,
  pageType: string,
  collection: object,
  sections: array,
  hamburgerMenu: array,
  domainInfo: object,
  domainSlug: string,
  navbarMenu: array,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
    pageType: get(state, ["qt", "pageType"], ""),
    collection: get(state, ["qt", "data", "collection"], []),
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondarySectionHeaderTopContent);
